'use strict';
var tslib_1 = require("tslib");
module.exports = rfdc;
function copyBuffer(cur) {
    if (cur instanceof Buffer) {
        return Buffer.from(cur);
    }
    return new cur.constructor(cur.buffer.slice(), cur.byteOffset, cur.length);
}
function rfdc(opts) {
    var e_1, _a;
    opts = opts || {};
    if (opts.circles)
        return rfdcCircles(opts);
    var constructorHandlers = new Map();
    constructorHandlers.set(Date, function (o) { return new Date(o); });
    constructorHandlers.set(Map, function (o, fn) { return new Map(cloneArray(Array.from(o), fn)); });
    constructorHandlers.set(Set, function (o, fn) { return new Set(cloneArray(Array.from(o), fn)); });
    if (opts.constructorHandlers) {
        try {
            for (var _b = tslib_1.__values(opts.constructorHandlers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var handler_1 = _c.value;
                constructorHandlers.set(handler_1[0], handler_1[1]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    var handler = null;
    return opts.proto ? cloneProto : clone;
    function cloneArray(a, fn) {
        var keys = Object.keys(a);
        var a2 = new Array(keys.length);
        for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            var cur = a[k];
            if (typeof cur !== 'object' || cur === null) {
                a2[k] = cur;
            }
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
                a2[k] = handler(cur, fn);
            }
            else if (ArrayBuffer.isView(cur)) {
                a2[k] = copyBuffer(cur);
            }
            else {
                a2[k] = fn(cur);
            }
        }
        return a2;
    }
    function clone(o) {
        if (typeof o !== 'object' || o === null)
            return o;
        if (Array.isArray(o))
            return cloneArray(o, clone);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) {
            return handler(o, clone);
        }
        var o2 = {};
        for (var k in o) {
            if (Object.hasOwnProperty.call(o, k) === false)
                continue;
            var cur = o[k];
            if (typeof cur !== 'object' || cur === null) {
                o2[k] = cur;
            }
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
                o2[k] = handler(cur, clone);
            }
            else if (ArrayBuffer.isView(cur)) {
                o2[k] = copyBuffer(cur);
            }
            else {
                o2[k] = clone(cur);
            }
        }
        return o2;
    }
    function cloneProto(o) {
        if (typeof o !== 'object' || o === null)
            return o;
        if (Array.isArray(o))
            return cloneArray(o, cloneProto);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) {
            return handler(o, cloneProto);
        }
        var o2 = {};
        for (var k in o) {
            var cur = o[k];
            if (typeof cur !== 'object' || cur === null) {
                o2[k] = cur;
            }
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
                o2[k] = handler(cur, cloneProto);
            }
            else if (ArrayBuffer.isView(cur)) {
                o2[k] = copyBuffer(cur);
            }
            else {
                o2[k] = cloneProto(cur);
            }
        }
        return o2;
    }
}
function rfdcCircles(opts) {
    var e_2, _a;
    var refs = [];
    var refsNew = [];
    var constructorHandlers = new Map();
    constructorHandlers.set(Date, function (o) { return new Date(o); });
    constructorHandlers.set(Map, function (o, fn) { return new Map(cloneArray(Array.from(o), fn)); });
    constructorHandlers.set(Set, function (o, fn) { return new Set(cloneArray(Array.from(o), fn)); });
    if (opts.constructorHandlers) {
        try {
            for (var _b = tslib_1.__values(opts.constructorHandlers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var handler_2 = _c.value;
                constructorHandlers.set(handler_2[0], handler_2[1]);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    var handler = null;
    return opts.proto ? cloneProto : clone;
    function cloneArray(a, fn) {
        var keys = Object.keys(a);
        var a2 = new Array(keys.length);
        for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            var cur = a[k];
            if (typeof cur !== 'object' || cur === null) {
                a2[k] = cur;
            }
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
                a2[k] = handler(cur, fn);
            }
            else if (ArrayBuffer.isView(cur)) {
                a2[k] = copyBuffer(cur);
            }
            else {
                var index = refs.indexOf(cur);
                if (index !== -1) {
                    a2[k] = refsNew[index];
                }
                else {
                    a2[k] = fn(cur);
                }
            }
        }
        return a2;
    }
    function clone(o) {
        if (typeof o !== 'object' || o === null)
            return o;
        if (Array.isArray(o))
            return cloneArray(o, clone);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) {
            return handler(o, clone);
        }
        var o2 = {};
        refs.push(o);
        refsNew.push(o2);
        for (var k in o) {
            if (Object.hasOwnProperty.call(o, k) === false)
                continue;
            var cur = o[k];
            if (typeof cur !== 'object' || cur === null) {
                o2[k] = cur;
            }
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
                o2[k] = handler(cur, clone);
            }
            else if (ArrayBuffer.isView(cur)) {
                o2[k] = copyBuffer(cur);
            }
            else {
                var i = refs.indexOf(cur);
                if (i !== -1) {
                    o2[k] = refsNew[i];
                }
                else {
                    o2[k] = clone(cur);
                }
            }
        }
        refs.pop();
        refsNew.pop();
        return o2;
    }
    function cloneProto(o) {
        if (typeof o !== 'object' || o === null)
            return o;
        if (Array.isArray(o))
            return cloneArray(o, cloneProto);
        if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) {
            return handler(o, cloneProto);
        }
        var o2 = {};
        refs.push(o);
        refsNew.push(o2);
        for (var k in o) {
            var cur = o[k];
            if (typeof cur !== 'object' || cur === null) {
                o2[k] = cur;
            }
            else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
                o2[k] = handler(cur, cloneProto);
            }
            else if (ArrayBuffer.isView(cur)) {
                o2[k] = copyBuffer(cur);
            }
            else {
                var i = refs.indexOf(cur);
                if (i !== -1) {
                    o2[k] = refsNew[i];
                }
                else {
                    o2[k] = cloneProto(cur);
                }
            }
        }
        refs.pop();
        refsNew.pop();
        return o2;
    }
}
//# sourceMappingURL=index.js.map